export const TYPE_OPTIONS = [
	{ id: 'reuse', label: 'reuse' },
	{ id: 'noreuse', label: 'noreuse' }
];
